import React from 'react'
import { Nav } from './Nav'
import { RoyaltiesCommissions } from './RoyaltiesCommissions'

// Renders children when given, so a page whose content changes with the URL
// keeps it mounted across navigations.
export const BasePage = ({ Comp, children }) => {
  return (
    <div className="ml-5 my-5">
      <div className="d-flex justify-space-between">
        <div className="minw-50">
          <Nav />
        </div>
        <div className="text-right minw-50">
          <RoyaltiesCommissions />
        </div>
      </div>
      <div className="">{children ?? <Comp />}</div>
    </div>
  )
}
